import React, { Component } from 'react'
import AuthenticationService from './AuthenticationService.js'

class LoginComponent extends Component {

    constructor(props) {
        super(props)
        this.state = {
            username: '',
            password: '',
            hasLoginFailed: false,
            loading: false,
        }
        this.handleChange = this.handleChange.bind(this)
        this.loginClicked = this.loginClicked.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value, hasLoginFailed: false })
    }

    handleKeyDown(event) {
        if (event.key === 'Enter') this.loginClicked()
    }

    loginClicked() {
        if (this.state.loading) return
        if (!this.state.username || !this.state.password) {
            this.setState({ hasLoginFailed: true })
            return
        }
        this.setState({ loading: true, hasLoginFailed: false })
        AuthenticationService
            .executeJwtAuthenticationService(this.state.username, this.state.password)
            .then((response) => {
                AuthenticationService.registerSuccessfulLoginForJwt(
                    this.state.username,
                    response.data.token,
                    response.data.authorities
                )
                this.props.history.push(`/welcome/${this.state.username}`)
            })
            .catch(() => {
                this.setState({ hasLoginFailed: true, loading: false })
            })
    }

    render() {
        const { username, password, hasLoginFailed, loading } = this.state

        return (
            <div style={styles.root}>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&family=Cinzel:wght@700;900&display=swap');

                    @keyframes float {
                        0%, 100% { transform: translateY(0px) rotate(-2deg); }
                        50% { transform: translateY(-18px) rotate(2deg); }
                    }
                    @keyframes fadeInUp {
                        from { opacity: 0; transform: translateY(30px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    @keyframes shimmer {
                        0% { background-position: -200% center; }
                        100% { background-position: 200% center; }
                    }
                    @keyframes shake {
                        0%, 100% { transform: translateX(0); }
                        20% { transform: translateX(-8px); }
                        40% { transform: translateX(8px); }
                        60% { transform: translateX(-4px); }
                        80% { transform: translateX(4px); }
                    }
                    @keyframes particles {
                        0% { transform: translateY(100vh); opacity: 0; }
                        10% { opacity: 1; }
                        90% { opacity: 1; }
                        100% { transform: translateY(-100px); opacity: 0; }
                    }
                    @keyframes pulse-ring {
                        0%   { box-shadow: 0 0 0 0 rgba(59,130,246,0.5); }
                        70%  { box-shadow: 0 0 0 14px rgba(59,130,246,0); }
                        100% { box-shadow: 0 0 0 0 rgba(59,130,246,0); }
                    }

                    .bdc-card { animation: fadeInUp 0.8s ease forwards; }

                    .particle {
                        position: absolute;
                        border-radius: 50%;
                        background: rgba(59,130,246,0.5);
                        animation: particles linear infinite;
                        pointer-events: none;
                    }

                    .skull-img {
                        animation: float 4s ease-in-out infinite;
                        filter: drop-shadow(0 0 20px rgba(59,130,246,0.5));
                    }
                    .skull-img:hover {
                        filter: drop-shadow(0 0 35px rgba(59,130,246,0.8));
                    }

                    .bdc-input {
                        width: 100%;
                        background: rgba(255,255,255,0.05);
                        border: 1px solid rgba(59,130,246,0.25);
                        border-radius: 10px;
                        padding: 14px 18px;
                        color: #e2e8f0;
                        font-family: 'Inter', sans-serif;
                        font-size: 0.92rem;
                        outline: none;
                        transition: all 0.3s;
                        box-sizing: border-box;
                    }
                    .bdc-input::placeholder { color: rgba(148,163,184,0.35); }
                    .bdc-input:focus {
                        border-color: rgba(59,130,246,0.7);
                        background: rgba(59,130,246,0.06);
                        box-shadow: 0 0 0 3px rgba(59,130,246,0.12);
                    }

                    .bdc-btn {
                        width: 100%;
                        padding: 15px;
                        background: linear-gradient(135deg, #2563eb, #3b82f6, #60a5fa, #3b82f6, #2563eb);
                        background-size: 200% auto;
                        border: none;
                        border-radius: 10px;
                        color: white;
                        font-family: 'Inter', sans-serif;
                        font-size: 0.88rem;
                        font-weight: 700;
                        letter-spacing: 3px;
                        text-transform: uppercase;
                        cursor: pointer;
                        transition: all 0.3s;
                        animation: shimmer 3s linear infinite;
                        box-shadow: 0 4px 20px rgba(59,130,246,0.35);
                    }
                    .bdc-btn:hover:not(:disabled) {
                        transform: translateY(-2px);
                        animation: pulse-ring 1.5s ease infinite, shimmer 1.5s linear infinite;
                    }
                    .bdc-btn:disabled { opacity: 0.6; cursor: not-allowed; }

                    .error-msg { animation: shake 0.5s ease; }
                `}</style>

                {/* Partículas azules */}
                {[...Array(35)].map((_, i) => (
                    <div key={i} className="particle" style={{
                        left: `${Math.random() * 100}%`,
                        animationDuration: `${8 + Math.random() * 12}s`,
                        animationDelay: `${Math.random() * 8}s`,
                        width: `${1.5 + Math.random() * 4}px`,
                        height: `${1.5 + Math.random() * 4}px`,
                        opacity: 0.2 + Math.random() * 0.5,
                    }} />
                ))}

                {/* Grid azul */}
                <div style={styles.grid} />

                <div className="bdc-card" style={styles.card}>

                    {/* Skull */}
                    <div style={styles.logoWrap}>
                        <img
                            src="/pshm6spshm6spshm.png"
                            alt="BDC"
                            className="skull-img"
                            style={styles.skull}
                            onError={(e) => { e.target.style.display = 'none' }}
                        />
                    </div>

                    {/* Título */}
                    <div style={styles.titleWrap}>
                        <h1 style={styles.title}>Cloud  Zenyth</h1>
                        <div style={styles.titleLine} />
                        <p style={styles.subtitle}>Acceso Restringido</p>
                    </div>

                    {/* Error */}
                    {hasLoginFailed && (
                        <div className="error-msg" style={styles.error}>
                            <span style={{marginRight: 8}}>⚠</span>
                            Credenciales inválidas
                        </div>
                    )}

                    {/* Campos */}
                    <div style={styles.fields}>
                        <div style={styles.fieldWrap}>
                            <label style={styles.label}>USUARIO</label>
                            <input
                                className="bdc-input"
                                autoComplete="off"
                                type="text"
                                name="username"
                                value={username}
                                onChange={this.handleChange}
                                onKeyDown={this.handleKeyDown}
                                placeholder="Nombre de usuario"
                            />
                        </div>
                        <div style={styles.fieldWrap}>
                            <label style={styles.label}>CONTRASEÑA</label>
                            <input
                                className="bdc-input"
                                type="password"
                                name="password"
                                value={password}
                                onChange={this.handleChange}
                                onKeyDown={this.handleKeyDown}
                                placeholder="••••••••"
                            />
                        </div>
                    </div>

                    <button className="bdc-btn" onClick={this.loginClicked} disabled={loading}>
                        {loading ? 'Verificando...' : 'Ingresar'}
                    </button>

                    <p style={styles.footer}>© 2026 Cloud Zenyth by KrvheD · Acceso autorizado únicamente</p>
                </div>
            </div>
        )
    }
}

const styles = {
    root: {
        minHeight: '100vh',
        backgroundImage: 'url(/High-Res.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        fontFamily: "'Inter', sans-serif",
    },
    grid: {
        position: 'absolute', inset: 0,
        backgroundImage: `
            linear-gradient(rgba(59,130,246,0.05) 1px, transparent 1px),
            linear-gradient(90deg, rgba(59,130,246,0.05) 1px, transparent 1px)
        `,
        backgroundSize: '60px 60px',
        pointerEvents: 'none',
    },
    card: {
        background: 'linear-gradient(145deg, rgba(10,15,30,0.72), rgba(15,23,42,0.80))',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        border: '1px solid rgba(59,130,246,0.25)',
        borderRadius: '20px',
        padding: '48px 40px 36px',
        width: '100%',
        maxWidth: '400px',
        position: 'relative',
        zIndex: 10,
        boxShadow: '0 25px 80px rgba(0,0,0,0.5), inset 0 1px 0 rgba(59,130,246,0.15)',
    },
    logoWrap: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '20px',
    },
    skull: {
        width: "130px",
        height: '130px',
        objectFit: 'contain',
        mixBlendMode: 'screen',
    },
    titleWrap: {
        textAlign: 'center',
        marginBottom: '28px',
    },
    title: {
        fontFamily: "'Cinzel', serif",
        fontSize: '1.65rem',
        fontWeight: '700',
        background: 'linear-gradient(135deg, #67e8f9 0%, #38bdf8 40%, #818cf8 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        margin: '0 0 8px',
        letterSpacing: '8px',
        textShadow: 'none',
        filter: 'drop-shadow(0 0 12px rgba(56,189,248,0.5))',
    },
    titleLine: {
        width: '60px', height: '2px',
        background: 'linear-gradient(90deg, transparent, #3b82f6, transparent)',
        margin: '8px auto 10px',
        borderRadius: '2px',
    },
    subtitle: {
        color: 'rgba(148,163,184,0.6)',
        fontSize: '0.7rem',
        letterSpacing: '4px',
        textTransform: 'uppercase',
        margin: 0,
    },
    error: {
        background: 'rgba(239,68,68,0.08)',
        border: '1px solid rgba(239,68,68,0.25)',
        borderRadius: '8px',
        color: '#fca5a5',
        padding: '12px 16px',
        fontSize: '0.85rem',
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
    },
    fields: {
        display: 'flex', flexDirection: 'column',
        gap: '16px', marginBottom: '24px',
    },
    fieldWrap: {
        display: 'flex', flexDirection: 'column', gap: '6px',
    },
    label: {
        color: 'rgba(148,163,184,0.6)',
        fontSize: '0.65rem',
        letterSpacing: '2px',
        fontWeight: '600',
    },
    footer: {
        textAlign: 'center',
        color: 'rgba(255,255,255,0.15)',
        fontSize: '0.7rem',
        marginTop: '20px',
        marginBottom: 0,
        letterSpacing: '0.5px',
    }
}

export default LoginComponent
